/*
 * Delugs Strap Finder — Shared Tab Renderer
 * ------------------------------------------------------------------
 * Renders the model-page tab UI (.sfl-main-tabs → .sfl-tab simple tabs +
 * .sfl-dropdown-tab material menus) and wires the colour chips, driving a
 * StrapFinderEngine instance. Used by surfaces that build tabs client-side
 * (homepage), so their tab markup is identical to the model page's.
 *
 * Dropdown material options are shop-wide (from shop.metaobjects.leather_straps),
 * passed in as `materialOptions`. The static colour-chip markup lives in the
 * section HTML (identical to the model page) and is wired here.
 *
 * Usage:
 *   var tabs = window.StrapFinderTabs({
 *     $, mainTabs, colourChips, engine, materialOptions, colourEncode
 *   });
 *   tabs.render(tabDescriptors);  // on watch select
 *
 * tabDescriptor = {
 *   key, label, collection, buyMode:'product'|'custom', isIntegrated:bool,
 *   dropdownGroup: 'leather'|'rubber'|'fabric'|'custom-rubber'|null,
 *   allCollection: handle|null,   // optional override for the "All" item
 *   titleFilter, excludeTitle
 * }
 */
(function () {
  'use strict';

  function esc(s) { return String(s == null ? '' : s).replace(/"/g, '&quot;'); }

  function StrapFinderTabs(config) {
    var $ = config.$ || window.jQuery;
    var mainTabs = config.mainTabs;          // .sfl-main-tabs element
    var colourWrap = config.colourChips || null; // #sfl-colour-chips element
    var engine = config.engine;
    var materialOptions = config.materialOptions || {}; // { leather:[], rubber:[], fabric:[] }

    var currentColour = '';
    var activeDef = null;
    var activeMaterial = '';

    function dropdownItems(group) {
      var items = [];
      if (group === 'custom-rubber') {
        items = [{ m: '', label: 'All Rubber' }, { m: 'Sailcloth', label: 'Sailcloth' }, { m: 'Rubberised Leather', label: 'Rubberised Leather' }];
      } else if (group === 'leather') {
        items.push({ m: '', label: 'All Leather' });
        (materialOptions.leather || []).forEach(function (o) { items.push({ m: o, label: o }); });
      } else if (group === 'rubber') {
        items.push({ m: '', label: 'All Rubber' });
        (materialOptions.rubber || []).forEach(function (o) { items.push({ m: o, label: o }); });
      } else if (group === 'fabric') {
        items.push({ m: '', label: 'All Fabric' });
        (materialOptions.fabric || []).forEach(function (o) { items.push({ m: o, label: o }); });
      }
      return items.map(function (it, i) {
        return '<button class="sfl-dropdown-item' + (i === 0 ? ' sfl-dropdown-item--active' : '') + '" data-sfl-material="' + esc(it.m) + '">' + esc(it.label) + '</button>';
      }).join('');
    }

    function render(tabs) {
      mainTabs.innerHTML = tabs.map(function (t, i) {
        var active = i === 0 ? ' active' : '';
        if (t.dropdownGroup) {
          return '<div class="sfl-dropdown-tab" data-i="' + i + '">'
            + '<button class="sfl-tab sfl-tab--has-menu' + active + '">' + esc(t.label) + ' <span class="sfl-tab__arrow">▾</span></button>'
            + '<div class="sfl-dropdown-menu">' + dropdownItems(t.dropdownGroup) + '</div>'
            + '</div>';
        }
        return '<button class="sfl-tab' + active + '" data-i="' + i + '">' + esc(t.label) + '</button>';
      }).join('');
      wire(tabs);
      if (tabs.length) activate(tabs[0], 0, '');
    }

    function setActive(idx) {
      $(mainTabs).find('.sfl-tab').removeClass('active');
      var node = mainTabs.querySelector('[data-i="' + idx + '"]');
      if (!node) return;
      if (node.classList.contains('sfl-dropdown-tab')) node.querySelector('.sfl-tab').classList.add('active');
      else node.classList.add('active');
    }

    function activate(t, idx, material) {
      if (!t) return;
      activeDef = t; activeMaterial = material || '';
      setActive(idx);
      showColourChips(!!t.dropdownGroup);
      load();
    }

    function load() {
      if (!activeDef) return;
      engine.loadTab({
        collection: activeDef.collection,
        material: activeMaterial || '',
        titleFilter: activeDef.titleFilter || '',
        titleExclude: activeDef.excludeTitle || '',
        colour: currentColour,
        buyMode: activeDef.buyMode,
        isIntegrated: activeDef.isIntegrated,
      });
    }

    function wire(tabs) {
      mainTabs.querySelectorAll('[data-i]').forEach(function (node) {
        var idx = parseInt(node.getAttribute('data-i'), 10);
        var t = tabs[idx];
        if (node.classList.contains('sfl-dropdown-tab')) {
          var btn = node.querySelector('.sfl-tab');
          btn.addEventListener('click', function (e) {
            e.stopPropagation();
            var wasOpen = node.classList.contains('sfl-dropdown-tab--open');
            closeAll();
            if (!wasOpen) {
              node.classList.add('sfl-dropdown-tab--open');
              if (!btn.classList.contains('active')) {
                node.querySelectorAll('.sfl-dropdown-item').forEach(function (d, di) { d.classList.toggle('sfl-dropdown-item--active', di === 0); });
                activate(t, idx, '');
              }
            }
          });
          node.querySelectorAll('.sfl-dropdown-item').forEach(function (item) {
            item.addEventListener('click', function (e) {
              e.stopPropagation();
              node.querySelectorAll('.sfl-dropdown-item').forEach(function (d) { d.classList.remove('sfl-dropdown-item--active'); });
              item.classList.add('sfl-dropdown-item--active');
              activate(t, idx, item.getAttribute('data-sfl-material') || '');
              closeAll();
            });
          });
        } else {
          node.addEventListener('click', function () { closeAll(); activate(t, idx, ''); });
        }
      });
    }

    function closeAll() { mainTabs.querySelectorAll('.sfl-dropdown-tab').forEach(function (d) { d.classList.remove('sfl-dropdown-tab--open'); }); }
    document.addEventListener('click', closeAll);

    // ── Colour chips ──
    function showColourChips(show) {
      if (!colourWrap) return;
      if (show) { colourWrap.style.display = ''; }
      else {
        colourWrap.style.display = 'none';
        currentColour = '';
        colourWrap.querySelectorAll('.sfl-colour-chip').forEach(function (c) { c.classList.remove('active'); });
        var all = colourWrap.querySelector('.sfl-colour-chip[data-sfl-colour=""]');
        if (all) all.classList.add('active');
      }
    }

    if (colourWrap) {
      colourWrap.addEventListener('click', function (e) {
        var more = e.target.closest('#sfl-colour-more');
        if (more) {
          var ov = colourWrap.querySelector('#sfl-colour-overflow');
          if (ov) { var on = ov.classList.toggle('show'); more.textContent = on ? 'Less' : '+7 more'; }
          return;
        }
        var chip = e.target.closest('.sfl-colour-chip[data-sfl-colour]');
        if (!chip) return;
        colourWrap.querySelectorAll('.sfl-colour-chip').forEach(function (c) { c.classList.remove('active'); });
        chip.classList.add('active');
        currentColour = chip.getAttribute('data-sfl-colour') || '';
        load();
      });
    }

    return { render: render };
  }

  window.StrapFinderTabs = StrapFinderTabs;
})();
